import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import styledTheme from '../../styles/theme'
import WindowCloseSquare from '../../components/icons/WindowCloseSquare'
import { closeMenu } from '../../actions/MenuActions'

const MenuScreenOverlay = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 15;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: ${({show}) => show ? 'flex' : 'none'};
  justify-content: flex-end;
  align-items: center;
`
const MenuCloseIconContainer = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
  svg {
    height: 28px;
    width: 28px;
    fill: #666;
  }
`
const MenuDiv = styled.div`
  display: ${({show}) => show ? 'inline-flex' : 'none'};
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  width: 300px;
  height: 100%;
  background-color: white;
  border-left: 1px solid black;
  box-shadow: -6px 0px 6px 1px #444;
`
const MenuDivInner = styled.div`
  margin-top: 80px;
  display: flex;
  overflow-y: scroll;
  flex-direction: column;
  width: 100%;
  padding: 0 20px;
  font-size: 14px;
`
const MenuTopLevelLink = styled.div`
  font-size: 20px;
  font-weight: bold;
  width: 100%;
  display: ${({show}) => show ? 'inline-flex' : 'none'};
  width: 100%;
  margin: 10px 0;
  a {
    text-decoration: none;
    width: 100%;
  }
`
const MenuH2 = styled.h2`
  display: inline-flex;
  width: 100%;
  margin: 10px 0;
`
const SubMenuLink = styled.div`
  font-size: 16px;
  font-weight: 500;
  display: inline-flex;
  width: 100%;
  margin: 8px 0;
  a {
    text-decoration: none;
    width: 100%;
    padding-left: 8px;
  }
`

class Menu extends React.Component {

  showSettings (event) {
    event.preventDefault()
  }

  closeMenuButtonHandler = () => {
    this.props.dispatch(closeMenu())
  }

  menuScreenOverlayOnClick = () => {
    this.props.dispatch(closeMenu())
  }

  menuDivOnClick = (e) => {
    e.stopPropagation()
  }

  linkClickHandler = () => {
    this.props.dispatch(closeMenu())
  }

  componentDidUpdate = (oldProps,oldState) => {
  }

  render () {
    const { menuOpen, hasDashboard, hasCombinedDataViews } = this.props
    let index = 0
    return (
      <MenuScreenOverlay show={menuOpen} onClick={this.menuScreenOverlayOnClick.bind(this)}>
        <MenuDiv show={menuOpen} onClick={this.menuDivOnClick.bind(this)}>
        <MenuCloseIconContainer onClick={this.closeMenuButtonHandler.bind(this)}><WindowCloseSquare /></MenuCloseIconContainer>
          <MenuDivInner>
            <MenuTopLevelLink key={index++} show={hasDashboard}><Link onClick={this.linkClickHandler.bind(this)} to={'/dashboard'}>Dashboard</Link></MenuTopLevelLink>
            <MenuTopLevelLink key={index++} show={true}><Link onClick={this.linkClickHandler.bind(this)} to={'/sites'}>Sites</Link></MenuTopLevelLink>
            <MenuTopLevelLink key={index++} show={hasCombinedDataViews}><Link onClick={this.linkClickHandler.bind(this)} to={'/combined_data_views'}>Combined Data Views</Link></MenuTopLevelLink>
            <MenuTopLevelLink key={index++} show={true}><Link onClick={this.linkClickHandler.bind(this)} to={'/management'}>Management</Link></MenuTopLevelLink>
            <MenuTopLevelLink key={index++} show={true}><Link onClick={this.linkClickHandler.bind(this)} to={'/help'}>Help</Link></MenuTopLevelLink>
            <MenuTopLevelLink key={index++} show={true}><Link onClick={this.linkClickHandler.bind(this)} to={'/logout'}>Logout</Link></MenuTopLevelLink>
          </MenuDivInner>
        </MenuDiv>
      </MenuScreenOverlay>
    );
  }
}

export default connect(
  (store, props) => {
    return ({
      routing: store.routing,
      apiAuth: store.apiAuth,
      menuOpen: store.menu.open,
      hasDashboard: store.apiAuth && store.apiAuth.user && store.apiAuth.user.has_dashboard,
      hasCombinedDataViews: store.apiAuth && store.apiAuth.user && store.apiAuth.user.has_combined_data_views,
    })
  },
)(Menu)



// WEBPACK FOOTER //
// ./src/containers/layout/Menu.js